import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { FilterKeys } from '../../../../../../shared/projectsV2/filters';
import * as ProjectsV2Store from '../../../../../redux/projectsV2';
import type { Project } from '../../../../../../shared/projectsV2/response';

import ProjectLabels from './ProjectLabels';
import ProjectTitle from './ProjectTitle';

type Props = {
  project: Project;
};

const ProjectOverview: VoidFunctionComponent<Props> = ({ project }: Props) => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter);
  const dispatch = useDispatch();

  const labelOnClick = (label: string) => {
    const labels = filter[FilterKeys.Labels] ?? [];
    if (labels.includes(label)) {
      return;
    }

    labels.push(label);
    dispatch(ProjectsV2Store.actions.setFilter({ ...filter, [FilterKeys.Labels]: labels }));
    dispatch(ProjectsV2Store.actions.fetchProjects());
  };

  return (
    <div className="project-item__overview">
      <ProjectTitle project={project} />
      {project.labels.length > 0 &&
        <ProjectLabels project={project} onClick={labelOnClick} />}
    </div>
  );
};

export default ProjectOverview;
